import { FormHelperText } from '@mui/material'
import { Stack } from '@dtx-company/design-system/src'
import React from 'react'
import ReportIcon from '@mui/icons-material/Report'

export const PaymentElementError: React.FC<{
  errorMessage?: string
  helperText?: string
}> = ({ errorMessage, helperText }) => {
  return (
    <FormHelperText error={Boolean(errorMessage)}>
      <Stack component="span" direction="row" gap={2} sx={{ alignItems: 'center' }}>
        {!!errorMessage && <ReportIcon />}
        {errorMessage || helperText}
      </Stack>
    </FormHelperText>
  )
}
